document.addEventListener('DOMContentLoaded', function() {
  // Function to handle button click event
  function handleButtonClick(event) { 
    syncBundleSizes(); // drop any add-on that doesn't fit the model chosen now, in case the model changed after it was ticked
    
    // Select all checkboxes with the name "bundle_add_to_cart[]"
    var checkboxes = document.querySelectorAll('input[name="bundle_add_to_cart[]"]');
    var checkedValues = [];

    // Iterate over each checkbox
    checkboxes.forEach(function(checkbox) {
      // Check if the checkbox is checked  
      if (checkbox.checked) {
      
        // Push the value of the checked checkbox into the checkedValues array
        checkedValues.push({ id: checkbox.value, quantity: parseInt(checkbox.getAttribute("data-qty"), 10) || 1 }); // per-add-on quantity from data-qty
      }
    });

    // Log the array of checked values
   // console.log("Checked values:", checkedValues); 
    if(checkedValues != ''){   
      $('.background-overlay').hide();
      //$('.background-overlay').css('opacity', 0);
      $('#halo-cart-sidebar').hide();
      $('shopify-payment-terms').hide();
    // Send AJAX request to Shopify to add products to cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: checkedValues }), // each item carries its own quantity
      contentType: "application/json",
      async:false,
      cache: false, // Disable caching
      dataType: 'json',
      success: function(data) {
       // alert('Products added to cart successfully!');
        // You can optionally redirect to the cart page after successful addition
        setTimeout(function(){  
            window.location.href = '/cart'; 
          
        }, 3000);
      },
      error: function(xhr, textStatus, errorThrown) {
        console.error('Error adding products to cart:', errorThrown);
      }
    });
   // alert(checkedValues);
  }else{
      $('.background-overlay').show();
      $('#halo-cart-sidebar').show();
      $('shopify-payment-terms').show();
   } 
  }

  // Add click event listener to buttons with class "product-form__submit"
  var submitButtons = document.querySelectorAll('#product-add-to-cart');
  submitButtons.forEach(function(button) {
    button.addEventListener('click', handleButtonClick); 
  });
 
 
    // Function to handle label click event
  function checkboxClick(event) {
    // Get the associated checkbox
    var checkbox = event.target.previousElementSibling;

    // Toggle the checked attribute of the associated checkbox
    checkbox.checked = !checkbox.checked;
    
    var checkboxes = document.querySelectorAll('input[name="bundle_add_to_cart[]"]');
    var paymentTermsElement = document.querySelector('shopify-payment-terms');
    var anyChecked = Array.from(checkboxes).some(function(checkbox) {
      return checkbox.checked;
    });
    if (anyChecked) {
      $('shopify-payment-terms').hide();
    } else {
      $('shopify-payment-terms').show();
    }
  }

  // Add click event listener to all labels with class "form-label--checkbox"
  var labels = document.querySelectorAll('.form-label--checkbox');
  labels.forEach(function(label) {
    label.addEventListener('click', checkboxClick);
  });
 
 // Show only the add-ons sized for the selected model, now and whenever the model changes
  syncBundleSizes();
  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches && e.target.matches('select[name="options[Model]"]')) syncBundleSizes();
  });

 // On chnage of variant option flor rate
   updateSelectedOptionValues();
  // Attach event listener to flowRateSelect for future changes
var flowRateSelect = document.querySelector('select[name="options[Flow Rate]"]');
if (flowRateSelect) flowRateSelect.addEventListener('change', updateSelectedOptionValues);
});

// Size-matched add-ons: rows carry data-bundle-size ("1in"/"2in", blank = always show).
// A model whose name contains any value in the section's data-large-models gets "2in"; others get "1in".
function currentBundleSize() {
  var section = document.querySelector('.bundle_product_options');
  var modelSelect = document.querySelector('select[name="options[Model]"]');
  if (!section || !modelSelect) return null;
  var model = modelSelect.value || '';
  var large = (section.getAttribute('data-large-models') || '').split(',');
  var isLarge = large.some(function(m) { m = m.trim(); return m && model.indexOf(m) !== -1; });
  return isLarge ? '2in' : '1in';
}

function syncBundleSizes() {
  var size = currentBundleSize();
  document.querySelectorAll('[data-bundle-row]').forEach(function(row) {
    var rowSize = row.getAttribute('data-bundle-size');
    var fits = !size || !rowSize || rowSize === size;
    row.style.display = fits ? '' : 'none';
    if (!fits) {
      var checkbox = row.querySelector('input[name="bundle_add_to_cart[]"]');
      if (checkbox) checkbox.checked = false;
    }
  });
  var anyChecked = Array.from(document.querySelectorAll('input[name="bundle_add_to_cart[]"]')).some(function(c) { return c.checked; });
  if (!anyChecked && window.jQuery) $('shopify-payment-terms').show();
}

// Define the function to update selected option values
function updateSelectedOptionValues() {
  // On change of variant option flow rate
  var flowRateSelect = document.querySelector('select[name="options[Flow Rate]"]');
  if (!flowRateSelect) return;
  var targetSelects = document.querySelectorAll('.select__target');

  // Get the selected option's value
  var selectedValue = flowRateSelect.value;

  // Find the corresponding select element with class select__target
  targetSelects.forEach(function(select) {
    // Find the option with the same value as selectedValue
    var option = select.querySelector('option[value="' + selectedValue + '"]');
   
    // If the option is found, retrieve its data-variantid attribute
    if (option) {
      var variantId = option.getAttribute('data-varidantid');
      var previousId = option.getAttribute('data-previoustId');
      var variantPrice = option.getAttribute('data-Variant-price');
      
      // Set the option as selected
      option.selected = true;
      
      // Update the input value if an input element exists with the previous ID
      var inputElement = document.getElementById('pr-bundle-'+previousId);  
      if (inputElement) {  
        inputElement.value = variantId; // Set the value to the variantId 
      }
      var priceElement = document.getElementById('price-bundle-'+previousId);  
      if (priceElement) {  
        priceElement.textContent  = '+' + variantPrice; // Set the price  to the variantId 
      }
      
    }
  });
}

